import { ProfileImage } from '@/entities/profile-page/ProfileImage/ui/ProfileImage'
import './ui/ProfileImage.css'
export default ProfileImage
